import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'app-quest-item-info-dialog',
  templateUrl: './quest-item-info-dialog.component.html',
  styleUrls: ['./quest-item-info-dialog.component.scss'],
})
export class QuestItemInfoDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<QuestItemInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }


}

export interface DialogData {
  name: string
  info: string
}
